// extracted by mini-css-extract-plugin
export default {"headerBlock":"header_headerBlock__U2gdR","header":"header_header__z8ezc","logoText":"header_logoText__F6QVE","subText":"header_subText__1plp4"};